import { jobBoardsApi } from "@/api/jobBoardsApi";
import { safePrefetch } from "@/utils/prefetchUtils";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Custom hook for prefetching settings data
 * Automatically prefetches data when user enters settings
 */
export const useSettingsPrefetch = (user) => {
  const location = useLocation();
  const dispatch = useDispatch();

  const isInSettings = location.pathname.startsWith("/employers/settings");
  const shouldPrefetch =
    isInSettings &&
    user?.employerId &&
    user?.employerProfile?.jobBoards?.length;

  // Prefetch settings data using dispatch without subscription
  useEffect(() => {
    if (shouldPrefetch) {
      const queryParams = {
        employerPermalink: user?.employerId,
        jobBoardPermalink: user?.employerProfile?.jobBoards?.[0]?.permalink,
      };

      safePrefetch(
        dispatch,
        jobBoardsApi.endpoints.getJobBoardJobDepartments.initiate,
        { ...queryParams }
      );
      safePrefetch(
        dispatch,
        jobBoardsApi.endpoints.getJobBoardJobOffices.initiate,
        { ...queryParams }
      );
    }
  }, [
    shouldPrefetch,
    dispatch,
    user?.employerId,
    user?.employerProfile?.jobBoards,
  ]);
};
